export default {
  swaps_received: [],
  swaps_sended: [],
}
